import React from 'react';
import styled from 'styled-components';
import Iframe from 'react-iframe';

import { useTranslate } from '../../translate/I18n';
import { assetize } from '../../utils/pureUtils';
import { externalRoutes } from '../../routes';

import Box from '../atoms/Box';
import Button from '../atoms/Button';
import Card from '../atoms/Card';
import Text from '../atoms/Text';
import DiscordIcon from '../atoms/icons/Discord';

const {
  discord: { freelancersCommunity: freelancersCommunityUrl, connect: connectToDiscordUrl }
} = externalRoutes;

const StyledIframe = styled(Iframe)({
  border: 0,
  width: '100%',
  maxWidth: '350px',
  minWidth: '250px',
  minHeight: '230px',
  margin: '0px auto'
});

const DiscordCard = styled(Card)(({ theme, backgroundImage }) => ({
  backgroundImage: `url(${backgroundImage})`,
  backgroundPosition: '50% 50px',
  backgroundSize: '500px',
  backgroundRepeat: 'no-repeat',
  backgroundColor: theme.colors.dark,
  color: theme.colors.white
}));

const Discord = () => {
  const { t } = useTranslate(['common', 'community']);

  const redirectToDiscord = () => {
    window.open(connectToDiscordUrl, '_blank');
  };

  return (
    <DiscordCard data-cy="discord-card" overflow="hidden" backgroundImage={assetize('/discord-bg.png')}>
      <Box px={5} display="flex" flexDirection={{ _: 'column', lg: 'row' }} bg="rgba(17, 21, 23, .4)">
        <Box py={3} mr={2} display="flex" flexDirection="column" alignItems="start">
          <Text styleName="pH2" mb={1}>
            {t('community:discord:title')}
          </Text>
          <Text mb={3} pr={2}>
            {t('community:discord:description')}
          </Text>
          <Button data-cy="btn-discord" styleType="white" onClick={redirectToDiscord} mt="auto">
            <DiscordIcon />
            {t('community:discord:cta')}
          </Button>
        </Box>
        <Box ml={{ _: 0, lg: 'auto' }} my={1}>
          <StyledIframe
            title="Discord"
            src={freelancersCommunityUrl}
            frameborder="0"
            allowtransparency="true"
            sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
          />
        </Box>
      </Box>
    </DiscordCard>
  );
};

export default Discord;
